import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const sendEmailXpo = createProvider(api.sendEmailXpo).andCatch((error) => {
  if (error instanceof Error && error.name === 'AbortError') {
    console.warn('Send email to XPO aborted');
  } else {
    console.error('Send email to XPO was failed:', error);
  }
  throw error;
});
